import React from "react";
import { Heading, Flex, Box } from "rebass";

export default function Expertise() {
  return (
    <section>
      <Flex flexWrap="wrap" alignItems="center" variant="containerPage">
        <Box>
          <Heading as="h1" variant="bigTitle" className="uppercase">
            Design <br/>
            Across <br/>
            Disciplines
          </Heading>
        </Box>
        <Box
          order={[1, 2]}
          width={[1 / 1]}
          mb={[4, 6]}
          sx={{ position: "relative" }}
        >
        </Box>
      </Flex>
    </section>
  );
}